var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 13.3332H2.66669M11.8095 3.42841V7.23793C11.8095 9.34187 10.104 11.0475 8.00002 11.0475C5.89608 11.0475 4.1905 9.34187 4.1905 7.23793V3.42841M3.04764 2.6665H5.33335M10.6667 2.6665L12.9524 2.6665",
    stroke: "#8897AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline01);
export default __webpack_public_path__ + "static/media/underline-01.c8718fb2e4285c287f6b7b552a013175.svg";
export { ForwardRef as ReactComponent };